import request from "@/api";
import { BaseService } from "@/api/services/baseService";
import type { CustomerFavoriteDetailVo, Page, CustomerFavoritePagingParams } from "@zhihaoscm/entity";

// 客户
export class CustomerFavoriteService extends BaseService<unknown, unknown, unknown, unknown> {
    public async paging(params: CustomerFavoritePagingParams): Promise<Page<CustomerFavoriteDetailVo>> {
        const { data } = await this.service.request({
            method: "get",
            url: `${this.path}/paging`,
            params: params
        });
        return data;
    }
}
export const customerFavoriteService = new CustomerFavoriteService("/admin/customer-favorite-detail", request.service);
